import {
  ArrowRight,
  GraduationCap,
  Home,
  FileText,
} from "lucide-react";

// Composant Button
// const Button = ({
//   children,
//   variant = "default",
//   className = "",
//   onClick,
//   ...props
// }) => {
//   const baseClasses =
//     "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
//   const variants = {
//     default: "bg-blue-600 text-white hover:bg-blue-700 h-10 px-4 py-2",
//     outline: "border border-gray-300 bg-white hover:bg-gray-50 h-10 px-4 py-2",
//     secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200 h-10 px-4 py-2",
//     ghost: "hover:bg-gray-100 text-gray-700 h-10 px-4 py-2",
//     link: "text-blue-600 hover:underline p-0 h-auto",
//     primary: "bg-green-600 text-white hover:bg-green-700 h-10 px-6 py-2",
//   };

//   return (
//     <button
//       className={`${baseClasses} ${variants[variant]} ${className}`}
//       onClick={onClick}
//       {...props}
//     >
//       {children}
//     </button>
//   );
// };

// Données des vidéos du carrousel
// const carouselVideos = [
//   {
//     id: 1,
//     title: "Découvrez les universités du Kenya",
//     description: "Explorer les meilleures institutions académiques du pays",
//     videoUrl:
//       "https://player.vimeo.com/external/370331493.sd.mp4?s=e90dcaba73c19e0e36f03406b47bbd6992dd6c1c&profile_id=139&oauth2_token_id=57447761",
//     thumbnail:
//       "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
//   },
//   {
//     id: 2,
//     title: "Logements étudiants à Nairobi",
//     description: "Options de logement pour tous les budgets",
//     videoUrl:
//       "https://player.vimeo.com/external/434045526.sd.mp4?s=c27eecc69a27dbc4ff2b87d38afc35f1a9e7c01d&profile_id=139&oauth2_token_id=57447761",
//     thumbnail:
//       "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
//   },
//   {
//     id: 3,
//     title: "Guide complet pour étudier au Kenya",
//     description: "Tout ce que vous devez savoir pour réussir vos études",
//     videoUrl:
//       "https://player.vimeo.com/external/371839264.sd.mp4?s=3c1ce599bd8bf5f5b5fc8f64c5301887d7f6cd16&profile_id=139&oauth2_token_id=57447761",
//     thumbnail:
//       "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
//   },
// ]

// Données des sections de la page d'accueil
const homeSections = [
  {
    id: "universities",
    title: "Universités",
    description:
      "Découvrez les meilleures universités du Kenya, leurs programmes d'études et leurs spécialités. Nous avons rassemblé toutes les informations essentielles pour vous aider à faire le meilleur choix pour votre avenir académique.",
    icon: <GraduationCap className="h-8 w-8 text-green-600" />,
    image: "/img/etudiantDos.jpeg",
    buttonText: "Explorer les universités",
    buttonLink: "/mksp/guide/university",
    color: "green",
  },
  {
    id: "housing",
    title: "Logements",
    description:
      "Trouvez le logement étudiant idéal à Nairobi et dans les autres villes universitaires du Kenya. Résidences universitaires, appartements partagés, studios privés - comparez les options et faites le meilleur choix selon votre budget.",
    icon: <Home className="h-8 w-8 text-blue-600" />,
    image: "/img/Paris_Room_13-Edit.jpeg",
    buttonText: "Découvrir les logements",
    buttonLink: "/mksp/guide",
    color: "blue",
  },
  {
    id: "guide",
    title: "Guide Étudiant",
    description:
      "Notre guide complet couvre tout ce que vous devez savoir pour étudier au Kenya : visa étudiant, documents nécessaires, choix d'université, logement, et recommandations importantes pour réussir votre séjour.",
    icon: <FileText className="h-8 w-8 text-purple-600" />,
    image: "/img/guide2.jpeg",
    buttonText: "Consulter le guide",
    buttonLink: "/mksp/guide",
    color: "blue",
  },
];

// Composant Carrousel Vidéo


function HomeComponent() {
  return (
    <div className="min-h-screen reveal dark:bg-gray-900 bg-white">
      {/* Hero Section avec Carrousel */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* <HomeCarousel/> */}
        {/* <VideoCarousel /> */}
      </section>

      {/* Introduction */}
      {/* <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Votre guide complet pour étudier au Kenya</h2>
            <p className="text-lg text-gray-600 mb-8">
              Nous vous accompagnons dans toutes les étapes de votre parcours académique au Kenya, de la sélection de
              l'université idéale à la recherche du logement parfait, en passant par les démarches administratives.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button variant="primary" onClick={() => onNavigate("guide")} className="text-base">
                Commencer votre aventure
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button variant="outline" onClick={() => onNavigate("about")} className="text-base">
                En saStudentHousingAdress
              </Button>
            </div>
          </div>
        </div>
      </section> */}

      {/* Sections principales */}
      <section className="  reveal reveal">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
          <div className="space-y-24">
            {homeSections.map((section, index) => (
              <div
                key={index} // ✅ Clé unique pour chaque section
                className={`flex flex-col ${
                  index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                } gap-8 items-center`}
              >
                {/* Partie image */}
                <div className="md:w-1/2">
                  <div className="h-3 w-full rounded-b rounded-full bgC bg-gradient-to-r from-pink-500 via-orange-400 to-yellow-400"></div>
                  <div className="relative">
                    {/* Couleur dynamique conservée */}
                    <div
                      className={`absolute -inset-4 rounded-xl bg-${section.color}-100 opacity-50 -z-10 transform -rotate-2`}
                    ></div>

                    <img
                      src={section.image}
                      alt={section.title}
                      className="shadow-lg w-full h-80 object-cover"
                    />
                  </div>
                </div>

                {/* Partie texte */}
                <div className="md:w-1/2">
                  <div className="flex items-center space-x-3 mb-4">
                    {section.icon}
                    <h2 className="text-2xl font-bold dark:text-gray-200 text-gray-900">
                      {section.title}
                    </h2>
                  </div>

                  <p className="dark:text-gray-400 text-gray-600 mb-6">
                    {section.description}
                  </p>

                  <a
                    href={section.buttonLink}
                    className={`bg-${section.color}-600 inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-100 rounded-lg border border-gray-300 hover:bg-green-500 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-green-500 dark:focus:ring-gray-800 hover:bg-${section.color}-700`}
                  >
                    {section.buttonText}
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-16 reveal dark:bg-gray-900  ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-12 dark:text-gray-200 text-center">
            Ce que disent nos utilisateurs
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white dark:bg-gray-800  rounded-lg shadow-md">
              <div className="flex p-6 items-center mb-4">
                <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-xl">
                  C
                </div>
                <div className="ml-4">
                  <h3 className="font-medium">Camille</h3>
                  <p className="text-sm dark:text-gray-200 text-gray-500">
                    Étudiante française
                  </p>
                </div>
              </div>
              <p className="text-gray-600 p-7 dark:text-gray-200 ">
                "Ce site m'a sauvé la vie ! Grâce au guide détaillé sur les
                visas, j'ai pu préparer tous mes documents sans stress. La
                section sur les logements m'a aussi permis de trouver un
                appartement avant même d'arriver au Kenya."
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800  rounded-lg shadow-md">
              <div className="flex items-center  p-6 mb-4">
                <div className="h-12 w-12  rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold text-xl">
                  P
                </div>
                <div className="ml-4 ">
                  <h3 className="font-medium">Patrick</h3>
                  <p className="text-sm dark:text-gray-200 text-gray-500">
                    Étudiant congolais
                  </p>
                </div>
              </div>
              <p className="text-gray-600 p-7 dark:text-gray-200 ">
                "La comparaison des universités m'a vraiment aidé à choisir
                celle qui correspondait le mieux à mes besoins. Les informations
                sont précises et à jour, ce qui est rare pour les ressources sur
                l'éducation en Afrique de l'Est."
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md">
              <div className="flex  p-6 items-center mb-4">
                <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-bold text-xl">
                  E
                </div>
                <div className="ml-4">
                  <h3 className="font-medium">Emily</h3>
                  <p className="text-sm dark:text-gray-200 text-gray-500">
                    Étudiante américaine
                  </p>
                </div>
              </div>
              <p className="text-gray-600 p-7 dark:text-gray-200 ">
                "Les recommandations de sécurité et les conseils pratiques du
                guide étudiant sont inestimables. J'ai pu m'adapter rapidement à
                la vie à Nairobi grâce à ces informations. Je recommande ce site
                à tous les étudiants internationaux !"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="py-16 bgC reveal dark:bg-gray-800 mb-10 from-green-600 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl font-bold mb-6">Tout ce que vous devez savoir pour étudier au Kenya offert par le service My Kenya Student Process</h2>
          <p className=" mb-8 max-w-3xl mx-auto">
            Explorez nos ressources complètes et préparez-vous pour une expérience d'études inoubliable.
            </p>
            <div className="flex  flex-wrap justify-center gap-4">
            <a href="/mksp/guide/free"
            
            
            className="bg-gray-900 rounded border dark:bg-green-700 dark:text-gray-100 text-gray-100 hover:bg-green-700 text-base px-8 py-3 h-auto"
            >
              Explorer les universités
            </a>
            <a href="/mksp/guide"
              
              
              className="border-white bg-green-700 rounded dark:bg-green-700 dark:text-gray-100 text-white hover:bg-green-500 text-base px-8 py-3 h-auto"
            >
              Consulter le guide premium
            </a>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default HomeComponent;
